import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const META_MAP = {
  '/': {
    title: 'Studio Medico Boscovich - Milano | Prenota il tuo appuntamento',
    description: 'Studio Medico Boscovich, Via Settembrini 7, Milano. Specialisti in ginecologia, allergologia, dermatologia, endocrinologia, pediatria. Prenota online il tuo appuntamento.',
    keywords: 'studio medico milano, ginecologia milano, allergologia, prenota appuntamento medico, studio medico boscovich'
  },
  '/chi-siamo': {
    title: 'Chi Siamo - Studio Medico Boscovich Milano',
    description: 'Scopri la storia e i valori dello Studio Medico Boscovich. Da oltre 30 anni al servizio della salute a Milano con un team di specialisti qualificati.',
    keywords: 'chi siamo, studio medico, storia, valori, milano'
  },
  '/servizi': {
    title: 'I Nostri Servizi Medici - Studio Medico Boscovich',
    description: 'Servizi medici specialistici: ginecologia, allergologia, diagnostica per immagini, dermatologia, endocrinologia, pediatria e vaccinazioni.',
    keywords: 'servizi medici, ginecologia, allergologia, ecografia, dermatologia, endocrinologia, pediatria, vaccinazioni'
  },
  '/equipe': {
    title: 'Equipe Medica - Studio Medico Boscovich Milano',
    description: 'Conosci i nostri specialisti. Un team di medici qualificati e aggiornati per la tua salute. Prenota una visita con il tuo specialista.',
    keywords: 'equipe medica, dottori, specialisti, medici milano'
  },
  '/contatti': {
    title: 'Contatti - Studio Medico Boscovich | Via Settembrini 7, Milano',
    description: 'Contattaci: Via Settembrini 7, Milano. Tel. 02.6693281. Orari: Lun-Ven 9-19, Sab 9-13. Email: info@studiomedicoboscovich.com',
    keywords: 'contatti, indirizzo, telefono, orari, come arrivare, studio medico boscovich'
  },
  '/faq': {
    title: 'FAQ - Domande Frequenti - Studio Medico Boscovich',
    description: 'Risposte alle domande piu frequenti su prenotazioni, documenti necessari, disdetta appuntamenti, costi e servizi dello studio.',
    keywords: 'faq, domande frequenti, prenotazione, documenti, disdetta, costi'
  },
  '/prenota': {
    title: 'Prenota Appuntamento - Studio Medico Boscovich',
    description: 'Prenota il tuo appuntamento online. Accedi al tuo account, scegli il servizio o il dottore e seleziona data e ora disponibili.',
    keywords: 'prenota appuntamento, prenotazione online, visita medica'
  },
};

export default function SEOHead() {
  const location = useLocation();

  useEffect(() => {
    const meta = META_MAP[location.pathname];
    if (meta) {
      document.title = meta.title;

      let descTag = document.querySelector('meta[name="description"]');
      if (!descTag) {
        descTag = document.createElement('meta');
        descTag.setAttribute('name', 'description');
        document.head.appendChild(descTag);
      }
      descTag.setAttribute('content', meta.description);

      let keyTag = document.querySelector('meta[name="keywords"]');
      if (!keyTag) {
        keyTag = document.createElement('meta');
        keyTag.setAttribute('name', 'keywords');
        document.head.appendChild(keyTag);
      }
      keyTag.setAttribute('content', meta.keywords);
    }
  }, [location.pathname]);

  return null;
}
